import * as React from "react"
import {
  CreateButton,
  DatagridConfigurable,
  List,
  SearchInput,
  TopToolbar,
  TextField,
  useListContext,
  useRecordContext,
  ImageField,
  DeleteWithConfirmButton,
  BulkDeleteButton
} from "react-admin"
import { useMediaQuery, Button, Box, Typography } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';

import PrintingMethodFilterForm from "./PrintingMethodFilterForm"

const TruncatedTextField = ({ source, maxLength = 30 }) => {
  const record = useRecordContext();
  const text = record?.[source] || '';
  const truncatedText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Typography variant="body2" title={text}>
      {truncatedText}
    </Typography>
  );
};

const PrintingMethodFilterButton = () => {
  const { showFilter } = useListContext()
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
      sx={{
        height: '27.5px', // 調整按鈕高度
        padding: '4px 5px', // 調整內邊距
        fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
      }}
    >
      篩選
    </Button>
  )
}

const visitorFilters = [
  <SearchInput source="q" alwaysOn />,
  // <DateInput source="last_seen_gte" />,
  // <NullableBooleanInput source="has_ordered" />,
  // <NullableBooleanInput source="has_newsletter" defaultValue />,
  // <SegmentInput source="groups" />
]

const ContactListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <PrintingMethodFilterButton />
      <CreateButton />
      {/* <SelectColumnsButton /> */}
      {/* <ExportButton /> */}
    </TopToolbar>
    <PrintingMethodFilterForm />
  </Box>
)

const PrintingMethodBulkActionButtons = () => (
  <>
    <BulkDeleteButton 
      confirmTitle="確認刪除"
      confirmContent="您確定要刪除這些印製方式嗎？"
      mutationMode="optimistic"
    />
  </>
);

const PrintingMethodTitle = () => {
  return <span>{'印製方式'}</span>;
};

const PrintingMethodList = () => {
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))
  return (
    <List
      title={<PrintingMethodTitle/>}
      filters={isSmall ? visitorFilters : undefined}
      sort={{ field: "name", order: "ASC" }}
      perPage={25}
      // aside={<ContactListAside />}
      actions={<ContactListActions />}
    >
      {isXsmall ? (
        // <MobileGrid />
        <div></div>
      ) : (
        <DatagridConfigurable
          rowClick="edit"
          bulkActionButtons={<PrintingMethodBulkActionButtons />}
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            }
          }}
          omit={["id"]}
        >
          <TextField
            source="id"
            label="ID"
          />
          <ImageField 
            source="imageUrl"
            sx={{ '& img': { maxWidth: 32, maxHeight: 32, objectFit: 'contain' } }}
            label="縮圖"
          />
          <TextField
            source="name"
            label="印製方式"
          />
          <TruncatedTextField 
            source="description" 
            maxLength={15} 
            label="描述"
          />
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此印製方式嗎？"
          />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default PrintingMethodList